module.exports = __webpack_public_path__ + "img/ring_r_l_null_1@2x.98fa3114.png";